export default __webpack_public_path__ + "static/media/TransportationSpaceships_04.fe9b10c9.png";